module.exports = __webpack_public_path__ + "static/logo-phrma-6e8f1af3b89bc8315974d4b1015c0971.png";